<template>
    <div style="width: 100%;height: 100%;background-color: #f3f4f9;">
        <div style="width: 100%;">
            <LayoutHeader route="enterprise"/>
            <div style="width: 100%;">
                <div class="banner-box">
                    <img src="@/assets/home/pingshen-banner.png" alt="">
                    <div class="text-box">
                        <div class="text1">精准评估信息化项目 · 推动数字资源汇聚 · 赋能企业高效发展</div>
                        <div class="text2">信息化项目评审</div>
                        <!-- <div class="button">查看我的评审</div>-->
                    </div>
                </div>
                <div class="breadBox">
                    <div class="child">
                        <a-breadcrumb>
            <span>
              当前位置：
            </span>
                            <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>信息化项目评审</a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                </div>
                <div class="search-container">
                    <!--                    <div class="title">信息化项目评审</div>-->
                    <div class="input-container">
                        <div>
                            <a-select
                                v-model:value="selectValue"
                                placeholder="请选择状态"
                                style="width:100px;height: 40px;margin-right: 20px;"
                                :options="statusList"
                            ></a-select>
                            <RangePicker style="width: 200px;height: 40px;margin-right: 20px;" v-model:value="dataTime"
                                         @change="changeTime"
                                         placeholder="请选择时间"/>
                            <a-input style="width: 680px;height: 40px;" v-model:value="searchKey"
                                     placeholder="请输入项目评审名称"></a-input>
                            <a-button @click="handleSearch">立即搜索</a-button>
                        </div>
                    </div>
                </div>
                <div class="contnet-02">
                    <div class="list-container">
                        <div class="list-item" v-for="item in dataSource" :key="item.id" @click="getDetailPage(item.id)">
                            <img v-if="isNoStart(item)" class="status-icon" src="../assets/svg/icon_no_start.png" alt="">
                            <img v-else-if="isInvalid(item)" class="status-icon" src="../assets/img/Invalid.png" alt="">
                            <img v-else-if="isOver(item)" class="status-icon" src="../assets/img/pingsheng-status02.png"
                                 alt="">
                            <img v-else-if="isRegisteredMax(item)" class="status-icon"
                                 src="../assets/img/pingshen-status03.png" alt="">
                            <img v-else-if="isRegistering(item)" class="status-icon"
                                 src="../assets/img/pingsheng-status01.png" alt="">

                            <div class="name">{{ item.projectReviewName }}</div>
                            <div class="info">
                                <div class="info-text">
                                    <img src="../assets/img/time-icon.png" alt="">
                                    <span class="detail-title">评审时间：</span><span>{{ truncateText(item.reviewTime) }}</span>
                                </div>
                                <div class="info-text">
                                    <img src="../assets/img/position.png" alt="">
                                    <span class="detail-title">评审地点：</span>{{ truncateText(item.reviewPlace) }}
                                </div>
                            </div>
                            <div class="content">
                                <!--<img src="../assets/img/pingshneg-gaishu.png" alt="">-->
                                <div style="margin:16px 0;" v-text="toText(item.projectOverview)"></div>
                            </div>

                        </div>
                    </div>
                    <div class="right-box">
                        <div class="text">评审专家劳务报酬</div>
                        <div class="text1">支付标准规定通知</div>
                        <div class="right-img">
                            <img @click="exportExcelTemplate(4)" src="../assets/home/xmps-img.png" alt="">
                            <img @click="exportExcelTemplate(5)" src="../assets/img/gygfzrrlwfzzsfpkjgzdtz.jpg" alt="">
                        </div>

                    </div>
                </div>
                <div class="pagination" style="width: 100%;display: flex;justify-content: center;padding-bottom: 40px;">
                    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper
                                  @change="onChange"/>
                </div>

            </div>
        </div>
        <LayoutFooter/>
    </div>
</template>

<script>
import {dictMixin, getDistMixin, listMixin} from "@/mixins";
import {file_service, login_mp, noticeInfoHome, sys_admin} from "@/api/adminService";
import {ls} from "@/utils/util"
import {enterpriseOperatingIncome} from "@/api/integral";
import {getBannerInfo, getWebInfo, noticeInfo} from "@/api/homeService";
import {platformName} from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import {applicationIndex} from "@/api/projectReviewService" // import RangePicker from "@/components/form/datePicker/RangePicker";
import axios from "axios";
import moment from "moment";
// const pagination = {
//   pageSize: 8,
//   showQuickJumper: true,
// };
export default {
    name: "index",
    components: {
        LayoutFooter,
        LayoutHeader
    },
    mixins: [dictMixin, getDistMixin, listMixin],
    data() {
        return {
            statusList: [
                {
                    value: '-1',
                    label: '全部'
                },
                {
                    value: '3',
                    label: '未开始'
                },
                {
                    value: '0',
                    label: '报名中'
                },
                {
                    value: '1',
                    label: '人数已满'
                },
                {
                    value: '2',
                    label: '已结束'
                },
                {
                    value: '4',
                    label: '已作废'
                }
            ],
            params: {
                pageSize: 6,
                pageNum: 1,
                total: 50
            },
            //   pagination,
            noticeData: [],
            scrollNoticeData: [],
            fourObj: {},
            user: {},
            getDetailNoteParam: null,
            operatingIncomeScale: null,
            platformName,
            getAuditStatus: null,
            visible: false,
            getDateId: null,
            formState: {
                user: undefined,
            },
            policyNotice: {},
            bannerData: [],
            webSiteInfo: {},
            linkData: [],

            queryParam: {
                // reviewStatus: 3
            },
            listUrl: applicationIndex.notLoginPage,
            current: 1,
            searchKey: '',
            dataTime: '',
            selectValue: '-1',
            pageSize: 5,
            str: null,
            // selectOption: [
            // 	{ label: '种子期(0（含）—100万元)', value: 1 },//seed
            // 	{ label: '初创期(100（含）—500万元)', value: 2 },//newly
            // 	{ label: '成长期(500（含）—2000万元)', value: 3 },//growth
            // 	{ label: '成熟期(2000（含）以上万元)', value: 4 }, //maturation
            // ],
        }
    },
    computed: {},
    methods: {
        canDo(record) {
            return record.reviewStatus === '3'
        },
        isNoStart(record) {
            return this.canDo(record) && moment(record.registerStartTime).isAfter(moment.now())
        },
        isRegistering(record) {
            const now = moment();
            const after = now.isAfter(moment(record.registerStartTime));
            // const before = now.isBefore(moment(record.registerEndTime));
            return this.canDo(record)
                && after
                // && before
                && this.isNoReview(record);
        },
        isRegisteredMax(record) {
            const max = (record.registeredCount || 0) === (record.reviewExpertCount || 0);
            return this.isRegistering(record) && max;
        },
        isEnd(record) {
            return this.canDo(record)
                && moment(record.registerEndTime).isBefore(moment.now())
                && this.isNoReview(record)
        },
        isNoReview(record) {
            const now = moment();
            return this.canDo(record) && moment(record.reviewTime).isAfter(now);
        },
        isOver(record) {
            const now = moment();
            return record.registeredStatus === '2' || '5,6,0'.includes(record.reviewStatus) || now.isAfter(record.reviewTime);
        },
        isInvalid(record) {
            return record.reviewStatus === '-1'
        },
        changeTime(time) {
            this.queryParam.startTime = time[0]
            this.queryParam.endTime = time[1]
            this.handleSearch()
        },
        handleSearch() {
            this.queryParam.projectReviewName = this.searchKey
            this.queryParam.status = this.selectValue
            this.loadData(1)
        },
        truncateText(text, maxLength) {
            // 定义一个最大字符数限制
            if (text && text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        exportExcelTemplate(type) {
            axios({
                method: 'post',
                url: applicationIndex.download,
                responseType: 'blob',
                params: {type:type}
            }).then(data => {
                console.log(data)
                // this.spinShow = false
                const blob = new Blob([data.data], {type: "application/excel"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                if (type == 4) {
                    link.download = decodeURIComponent('山西省财政厅关于印发政府采购评审专家劳务报酬支付标准暂行规定的通知.pdf');// 文件重命名，若无需重命名，将该行删去
                }else{
                    link.download = decodeURIComponent('关于规范自然人劳务费增值税发票开具工作的通知.pdf');// 文件重命名，若无需重命名，将该行删去
                }
                link.click();
                URL.revokeObjectURL(url); // 释放内存
            })
        },
        toText(html) {
            const pattern = /&nbsp;/g; // 匹配任何HTML标签
            return html.replace(pattern, '')
        },
        //   onChange(e){
        //       this.params.pageNum = e
        //       // console.log('Page: ', e);
        //   },
        getDetailPage(id) {
            this.$router.push('/projectReviewDetail?id=' + id)
        },
        logout() {
            let self = this;

            self.$ls.clear();
            self.$store.commit('setMenuData', []);
            self.$router.replace('/');

            location.reload();
        },
        onLogout() {
            let self = this;
            self.$confirm({
                title: '确认要退出登录?',
                content: '',
                onOk() {
                    self.postAction({
                        url: login_mp.saveLog,
                        params: {logAppCategoryEnum: "LOGOUT"}
                    }).then(res => {
                        console.log(res)
                        self.getAction({
                            url: login_mp.logout,
                            params: {access_token: ls.get("token") || ""},
                            isValid: false
                        }).then(() => {
                            self.$notification['success']({
                                message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        })
                    })


                    setTimeout(() => {
                        self.logout();
                    }, 2000)
                },
                onCancel() {
                },
            });
        },
        goMorePolicy() {
            this.$router.push({
                path: '/notice',
                // query: { type: "资讯公告", activeKey: 2 }
            })
        },
        goDetail(id, type) {
            this.$router.push({
                path: "/noticeDetail",
                query: {id: id, type: type}
            })
        },
        getUserInfo() {
            this.getAction({
                url: sys_admin.userInfor
            }).then(res => {
                sessionStorage.setItem("roleCode", res.roleCode.split(','));
            })
        },
        getNoticeInfo() {
            this.getAction({
                url: noticeInfo.pageList,
                params: {pageNum: 1, pageSize: 10}
            }).then(res => {
                this.noticeData = res.records
            })
        },
        getNoticeDownInfo() {
            this.getAction({
                url: noticeInfoHome.pageList,
                params: {pageNum: 1, pageSize: 10}
            }).then(res => {
                this.scrollNoticeData = res.records
            })
        },
        goHttp(url) {
            window.open(url, '_bank')
        },
        goMore(url, str) {
            this.$router.push({path: url, query: {id: str}})
        },
        goMoreNotice(url, str) {
            console.log('url: ', url, str)
            this.$router.push({path: url, query: {...str}})
        },
        getDetail() {
            this.getAction({
                url: enterpriseOperatingIncome.detail,
                params: {
                    id: this.getDateId.id,
                },
                returnMsg: true,
            }).then((res) => {
                this.getDetailNoteParam = res.data
                this.operatingIncomeScale = res.data.operatingIncomeScale
                this.getAuditStatus = res.data.auditStatus
            });
        },
        getDate() {
            this.getAction({
                url: enterpriseOperatingIncome.getDate,
                // params: { id: id },
                returnMsg: true,
            }).then((res) => {
                this.getDateId = res.data
                // auditStatus
            });
        },
        islogin() {
            if (ls.get('token') && ls.get("refresh_token")) {
                if (ls.get("roleCode").includes('company')) {
                    this.goMore('/sys/companyInfo')
                } else if (ls.get("roleCode").includes('technicalManager')) {
                    this.goMore('/sys/technology/person');
                } else if (ls.get("roleCode").includes('serviceOrganization')) {
                    this.goMore('/sys/innovation/organization/index');
                } else if (ls.get("roleCode").includes('investorManager')) {
                    this.goMore('/finance/investorInformation');
                } else if (ls.get("roleCode").includes('investmentMechanism')) {
                    this.goMore('/finance/investmentOrganizationInformation');
                } else if (ls.get("roleCode").includes('financialAdviser')) {
                    this.goMore('/finance/financialAdvisorInformation');
                } else if (ls.get("roleCode").includes('expert')) {
                    this.goMore('/sys/expertInfo');
                } else if (ls.get("roleCode").includes('gov-institution')) {
                    this.goMore("/sys/govInstitution")
                } else {
                    this.goMore('/sys/userInfo')
                }
            } else {
                this.goMore('/login', 'user')
            }
        },
        getBannerList() {
            this.getAction({
                url: getBannerInfo.pageList,
                params: {type: 'home'}
            }).then(res => {
                this.bannerData = res.records.reverse()
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getWebInfo() {
            this.getAction({
                url: getWebInfo.detail,
                params: {id: 1}
            }).then(res => {
                this.webSiteInfo = res
            })
        },
    },
    mounted() {
        if (ls.get('token') && ls.get("refresh_token")) {
            this.user.userName = this.$ls.get('userName')
            this.user.phoneNumber = this.$ls.get('phoneNumber')
        }
        this.getWebInfo()
    }
}
</script>

<style scoped lang="less">
.banner-box {
    position: relative;

    img {
        width: 100%;
        height: 282px;
        object-fit: cover;
    }

    .text-box {
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);
        .text1 {
            font-weight: 400;
            font-size: 20px;
            color: #57DACF;
            line-height: 50px;
            width: 100%;
        }

        .text2 {
            font-weight: 400;
            font-size: 40px;
            color: #FFFFFF;
            line-height: 50px;
            margin: 10px 0 30px 0;
            width: 100%;
        }

        .button {
            background: linear-gradient(90deg, #FF8F14, #FF5C0A);
            box-shadow: 0px 0px 1px 0px #FFFFFF;
            border-radius: 4px;
            color: #fff;
            width: 160px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
    }
}

:deep(.ant-pagination-item-active) {
    border-color: #0a2c83;
}

:deep(.ant-select-selector),
:deep(.ant-calendar-picker-input) {
    height: 40px !important;
    background: #F7F8FA !important;
    color: #999999 !important;
    border: none !important;
}

:deep(.ant-select-selection-item) {
    line-height: 40px !important;
}

:deep(.ant-pagination-item:hover),
:deep(.ant-pagination-item:hover a),
:deep(.ant-pagination-next:hover a),
:deep(.ant-pagination-prev:hover a),
:deep(.ant-pagination-options-quick-jumper input:focus) {
    border-color: #0a2c83 !important;
}

:deep(.ant-pagination-item-active a),
:deep(.anticon svg) {
    color: #0a2c83;
}
.contnet-02{
    width: 1200px;
    margin:0 auto;
    display:flex;
    justify-content: space-between;
    .right-box{
        position: relative;
        .text{
            cursor: pointer;
            font-weight: normal;
            font-size: 32px;
            color: #333333;
            line-height: 40px;
            background: linear-gradient(0deg, #3F67FF 0%, #55A2F9 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            position: absolute;
            top:40px;
            left:30px;
        }
        .text1{
            cursor: pointer;
            position: absolute;
            top:90px;
            left:30px;
            font-weight: normal;
            font-size: 32px;
            color: #333333;
            line-height: 40px;
            background: linear-gradient(0deg, #F3927B 0%, #EB584E 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .right-img{
        width: 340px;
        height: auto;
        img{
            cursor: pointer;
        }
        img + img{
            margin-top: 20px;
        }
    }
}
.list-container {
    width: 69%;
    .list-item:hover {
        border:1px solid #0059B5;
        .name{
            color: #0059B5;
        }
    }

    .list-item {
        width: 100%;
        margin-bottom: 26px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .1);
        padding: 20px;
        position: relative;
        cursor: pointer;
        background: #fff;
        border:1px solid #fff;

        .status-icon {
            position: absolute;
            top: 15px;
            right: 0;
        }

        .name {
            width: 80%;
            font-size: 22px;
            font-weight: bold;
            color: #333;
            white-space: nowrap; /* 确保文本在一行内显示 */
            overflow: hidden; /* 超出容器部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
        }

        .info {
            display: flex;
            flex-wrap: wrap;
            margin: 10px 0;
            color: #999999;
            border-bottom: 1px solid #DEDEDE;
            padding:10px 0  20px 0 ;
            .info-text:first-child {
                margin-right: 100px;
            }

            .info-text {
                display: flex;
                align-items: center;
                color: #999999;

                img {
                    margin-right: 6px;
                }
            }
        }

        .content {
            font-size: 16px;
            line-height: 26px;
            color: #666666;
            background: #fff;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
            overflow: hidden;
            text-overflow: ellipsis;

            img {
                margin-right: 4px;
            }
        }

        .detail-title {
            color: #999999;
        }
    }
}

.search-container {
    .title {
        font-size: 18px;
        color: #000;
        position: relative;
        z-index: 1;
        margin-bottom: 20px;
    }

    .title:before {
        content: '';
        position: relative;
        display: block;
        width: 72px;
        height: 6px;
        background: #ffcdb6;
        top: 24px;
        z-index: -1;
    }

    .input-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: #fff;

        .ant-input {
            height: 40px;
            border-radius: 4px;
            background: #F7F8FA;
            border:none;
            color: #999;
        }

        /*        .ant-input:hover{
                    border-color: #0a2c83;
                }*/

        .ant-btn {
            width: 120px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background: #0059B5;
            border: none;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 200;
            margin-left: 15px;
        }
    }
}

:deep(.ant-btn) {
    color: #fc550b;
    font-weight: 600;
    padding: 0 10px;

    img {
        margin-right: 5px
    }

    &:hover {
        border-color: #ffffff;
        box-shadow: 1px 1px 5px 1px #a7a7a7;
    }
}

.headerBox {
    width: 100%;
    height: 92px;
    background-color: #fff;

    .hearderContentBox {
        width: 1200px;
        margin: 0 auto;

        .titleBox {
            cursor: pointer;
            overflow: hidden;
            float: left;
            line-height: 92px;
            font-size: 30px;
            font-weight: bold;

            .logoBox {
                float: left;
                width: 73px;
                height: 66px;
                margin-right: 5px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .rightBox {
            float: right;
            display: flex;
            justify-content: space-around;
            line-height: 92px;
            font-size: 16px;

            a {
                font-weight: 600;
            }

            .loginBox {
                // float: left;
                cursor: pointer;
            }

            .loginBox:hover {
                color: #fc550b;
            }

            .lineBox {
                height: 18px;
                top: 36px;
            }

            .resigierBox {
                cursor: pointer;
                // float: left;
            }

            .resigierBox:hover {
                color: #fc550b;
            }
        }
    }
}

.bannerBox {
    position: relative;
    width: 100%;

    :deep(.ant-carousel) {
        position: relative;
        width: 100%;
    }

    .bannerImg {
        width: 100%;
        height: 282px;

        img {
            width: 100%;
            object-fit: cover;
            height: 280px;
        }
    }
}

.breadBox {
    width: 100% !important;
    padding:0 !important;
    border-bottom: 1px solid #DEDEDE;

    .child {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;

    }
}

::v-deep .anticon svg{
    color:#999;
}

.breadBox, .search-container {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
}


.cardBox {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: auto;
    margin: 0 auto;
    // background-color: #fff;

    .smallCardBox {
        margin: 36px auto;
        height: 46px;

        .leftImg {
            float: left;
            width: 46px;
            height: 46px;
            border-radius: 50%;
        }

        .rightText {
            float: left;
            margin-left: 5px;
            line-height: 46px;

            span {
                font-size: 24px;
                color: #0048c4;
            }
        }
    }
}

.contentBox {
    margin: 0 auto 20px auto;
    width: 1200px;
    height: auto;

    .menuBox {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        .smallMenuBox {
            position: relative;
            padding: 24px;
            width: 19%;
            background-color: #fff;
            cursor: pointer;
            border: 1px solid #e1f1fe;

            .menuImg {
                position: absolute;
                bottom: 10px;
                right: 6px;
            }

            .menuTitle {
                margin-bottom: 22px;
                font-size: 20px;
                font-weight: bold;
            }

            .titleInfo {
                width: 90%;
                font-size: 14px;
                color: #666;
                z-index: 11;
                position: relative;
            }

            .showMoreBtn {
                margin-top: 15px;
                background-color: #fff;
                width: 44%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                opacity: 0;
            }
        }

        .smallMenuBox:hover {
            background-color: #0a2c83;
            color: #fff;
            border: none;
            -webkit-transition: all 0.3s ease 0s;
            transition: all 0.3s ease 0s;
            //border: 1px solid #ffffff;
            cursor: pointer;
            -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
            box-shadow: 0 5px 10px 1px #d2e6ff;

            .titleInfo {
                color: #fff;
            }

            .showMoreBtn {
                opacity: 1;
            }
        }
    }
}

.pointsBox {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 55px 0;

    .recruitmentContentBox {
        padding: 14px 0;
        width: 100%;

        .moreList {
            float: right;
            margin-top: -21px;
            font-size: 14px;
            color: #999;
        }

        .moreList:hover {
            color: #0a2c83;
            cursor: pointer;
        }

        .listBox {
            position: relative;
            overflow: hidden;
            padding: 10px 0;
            cursor: pointer;
            border-bottom: 1px solid #dedede;

            .leftBox {
                float: left;
                width: 150px;
                height: 80px;
                text-align: center;
            }

            .right {
                float: left;
                margin-left: 2%;
                width: 74%;
                font-size: 14px;

                .title {
                    padding: 10px 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: 500;
                }

                .content {
                    overflow: hidden;
                    margin: 10px 0;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }

    .pagination {
        text-align: center;
        margin-bottom: 20px;
    }
}

.linkBig {
    width: 100%;
    background-color: #fff;

    .linkBox {
        overflow: hidden;
        font-size: 16px;
        color: #333;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;


        .leftLabel {
            float: left;
            width: 7%;
            font-weight: bold;
        }

        .rightBox {
            float: left;
            margin-left: 15px;
            width: 90%;
            // display: flex;
            // justify-items: start;
            // flex-wrap: wrap;

            .itemLink {
                float: left;
                margin-right: 30px;
                margin-bottom: 5px;
                color: #333;
                // text-decoration: underline;
            }

            .itemLink:hover {
                color: #0a2c83;
            }
        }
    }
}

.footerBox {
    width: 100%;
    background-color: #333333;

    .footerContent {
        position: relative;
        margin: 0 auto;
        padding: 24px 0;
        width: 1200px;

        .firstLine {
            padding: 8px 0;
            font-size: 14px;
            color: #999;

            span {
                margin-right: 18px;
            }
        }

        .footCode {
            position: absolute;
            right: 0;
            bottom: 12%;
            text-align: center;

            .footEwm {
                margin-bottom: 8px;
            }

            .footEwmTitle {
                color: #999;
            }
        }
    }
}

:deep(.ant-list-lg .ant-list-item) {
    padding: 16px 8px;
}

:deep(.ant-calendar-range-picker-separator) {
    line-height: 30px;
}

</style>
